import { ComponentChildren } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { Icon } from "../../../components";
import styles from "./Notification.module.scss";

export type NotificationType = "error" | "success" | "info";

interface NotificationProps {
  type: NotificationType;
  children: ComponentChildren;
  onClose?: () => void;
  autoClose?: boolean;
  duration?: number;
}

export const Notification = ({
  type,
  children,
  onClose,
  autoClose = true,
  duration = 3000,
}: NotificationProps) => {
  const [closing, setClosing] = useState(false);
  const closeTimeoutRef = useRef<number | null>(null);
  const removeTimeoutRef = useRef<number | null>(null);

  const startClose = () => {
    if (closing) return;
    setClosing(true);
    removeTimeoutRef.current = window.setTimeout(() => {
      onClose?.();
    }, 400);
  };

  useEffect(() => {
    if (!autoClose) return;
    closeTimeoutRef.current = window.setTimeout(() => {
      startClose();
    }, duration);
    return () => {
      if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
      if (removeTimeoutRef.current) clearTimeout(removeTimeoutRef.current);
    };
  }, [autoClose, duration]);

  return (
    <div
      className={`${styles.notification} ${styles[type]} ${closing ? styles.closing : ""}`}
    >
      <div className={styles.content}>
        <div className={styles.message}>{children}</div>
      </div>
      {onClose && type !== "success" && (
        <button className={styles.closeButton} onClick={startClose}>
          <Icon name="close" width={20} height={20} />
        </button>
      )}
    </div>
  );
};
